
  export const project = [
  {
    id: "1",
    name: "SafetyAi",
    heroTitle: "SAFETY.AI",
    heroHeading: "About Safety.Ai",
    description: `The objective of this project is to create a mobile application that enables patients to directly consult dermatologists. Users can fill out a consultation form, upload photos of their skin condition, and make online payments. Additionally, the app facilitates conversations between patients and dermatologists. The development of this innovative Flutter mobile application will cater to Dutch, French, and English-speaking users. The layout is thoughtfully arranged, making it easy for users to navigate through different sections and access the app's features seamlessly.

`,

    technologies: [
      {
        category: "Frontend",
        items: [
          { name: "React", color: "#61DAFB", icon: "FaReact" },
          { name: "TypeScript", color: "#3178C6", icon: "SiTypescript" },
          { name: "Tailwind CSS", color: "#06B6D4", icon: "SiTailwindcss" },
        ],
      },
      {
        category: "Backend",
        items: [
          { name: "Node.js", color: "#339933", icon: "FaNodeJs" },
          { name: "Express", color: "#000000", icon: "SiExpress" },
          { name: "Python", color: "#3776AB", icon: "FaPython" },
        ],
      },
      {
        category: "Database",
        items: [
          { name: "MongoDB", color: "#47A248", icon: "SiMongodb" },
          { name: "PostgreSQL", color: "#4169E1", icon: "SiPostgresql" },
          { name: "Redis", color: "#DC382D", icon: "SiRedis" },
        ],
      },
      {
        category: "DevOps",
        items: [
          { name: "Docker", color: "#2496ED", icon: "FaDocker" },
          { name: "Git", color: "#F05032", icon: "FaGitAlt" },
          { name: "Database", color: "#336791", icon: "FaDatabase" },
        ],
      },
    ],

    heroImage: "https://d19cx7uv5wsln6.cloudfront.net/assets/images/drskin-mobile.webp",

    // ===== Dynamic Sections for Project Details =====
    detailsSections: [
      {
        heading: "Safety AI App Project in Details",
        texts: [
          "We designed and developed an app specifically for patients seeking solutions to skin-related problems. Our goal is to ensure that patients receive prompt and accessible care whenever they need it.",
          "We designed and developed an app specifically for patients seeking solutions to skin-related problems. Our goal is to ensure that patients receive prompt and accessible care whenever they need it."
        ],
        card: {
          icon: "<IoPerson className='text-center h1' size={60} />", // render in JSX
          title: "Client Requirements",
          description: "Capture & highlight patient skin problem pictures, engage in direct conversations and save consultation progress as drafts.",
          backgroundColor: "#8d92ff",
          borderRadius: "28px",
          color: "white",
          width: "500px",
          height: "320px",
        }
      },
      {
        cards: [
          {
            icon: "<IoBagSharp className='text-center h1' size={60} />",
            title: "Results Oriented Execution",
            description: "Capture & highlight patient skin problem pictures, engage in direct conversations and save consultation progress as drafts.",
            backgroundColor: "#8d92ff",
            borderRadius: "28px",
            color: "white",
            width: "500px",
            height: "320px",
          },
          {
            icon: "<IoAirplane className='text-center h1' size={60} />",
            title: "Solutions We Offered",
            description: "Capture & highlight patient skin problem pictures, engage in direct conversations and save consultation progress as drafts.",
            backgroundColor: "#8d92ff",
            borderRadius: "28px",
            color: "white",
            width: "500px",
            height: "320px",
          }
        ]
      }
    ],

    sections: [
      {
        title: "Introduction Screen",
        subtitle: "Get Started: Journey to Healthy Skin",
        description: [
          `The application's introduction screen provides users with an overview of its features and functionalities.`,
          `Users can also switch between Dutch, French, and English languages.`,
        ],
        image: "https://d19cx7uv5wsln6.cloudfront.net/assets/images/dr-skin-fearures-img1.webp",
        reverse: false,
      },
      {
        title: "Home Screen",
        subtitle: "Welcome to the Dermatology Consult App",
        description: [
          `The Home screen displays ongoing or draft consultations.`,
          `It also provides an intuitive way to start new consultations.`,
        ],
        image: "https://d19cx7uv5wsln6.cloudfront.net/assets/images/dr-skin-fearures-img2.webp",
        reverse: true,
      },
      {
        title: "Consultation Screen",
        subtitle: "Expert Guidance at Your Fingertips",
        description: [
          `Shows a full overview of all consultations.`,
          `Users can view details, discussions, and attached files.`,
        ],
        image: "https://d19cx7uv5wsln6.cloudfront.net/assets/images/dr-skin-fearures-img3.webp",
        reverse: false,
      },
       {
        title: "Mobile & Web Screens",
        subtitle: "Seamless Design, Exceptional Experience",
        description: [
          `The mobile and web screens have been thoughtfully designed to provide a visually appealing and intuitive user experience.`,
          `The Mobile Screen is optimized for smartphones and tablets, featuring a responsive layout that adapts to different screen sizes.`,
          `The Web Screen offers a spacious and immersive layout for desktop and laptop users.`,
        ],
        image: "https://d19cx7uv5wsln6.cloudfront.net/assets/images/dr-skin-tab-mobile.webp",
        reverse: false,
      },
    ],
  },
   {
    id: "2",
    name: "FaceAI",
    heroTitle: "FACE.AI",
    heroHeading: "About Face AI Project",
    description: `The objective of this project is to create a mobile application that enables patients to directly consult dermatologists. Users can fill out a consultation form, upload photos of their skin condition, and make online payments. Additionally, the app facilitates conversations between patients and dermatologists. The development of this innovative Flutter mobile application will cater to Dutch, French, and English-speaking users. The layout is thoughtfully arranged, making it easy for users to navigate through different sections and access the app's features seamlessly.

`,

    technologies: [
      {
        category: "Frontend",
        items: [
          { name: "React", color: "#61DAFB", icon: "FaReact" },
          { name: "TypeScript", color: "#3178C6", icon: "SiTypescript" },
          { name: "Tailwind CSS", color: "#06B6D4", icon: "SiTailwindcss" },
        ],
      },
      {
        category: "Backend",
        items: [
          { name: "Node.js", color: "#339933", icon: "FaNodeJs" },
          { name: "Express", color: "#000000", icon: "SiExpress" },
          { name: "Python", color: "#3776AB", icon: "FaPython" },
        ],
      },
      {
        category: "Database",
        items: [
          { name: "MongoDB", color: "#47A248", icon: "SiMongodb" },
          { name: "PostgreSQL", color: "#4169E1", icon: "SiPostgresql" },
          { name: "Redis", color: "#DC382D", icon: "SiRedis" },
        ],
      },
      {
        category: "DevOps",
        items: [
          { name: "Docker", color: "#2496ED", icon: "FaDocker" },
          { name: "Git", color: "#F05032", icon: "FaGitAlt" },
          { name: "Database", color: "#336791", icon: "FaDatabase" },
        ],
      },
    ],

    heroImage: "https://d19cx7uv5wsln6.cloudfront.net/assets/images/drskin-mobile.webp",

    // ===== Dynamic Sections for Project Details =====
    detailsSections: [
      {
        heading: "Safety AI App Project in Details",
        texts: [
          "We designed and developed an app specifically for patients seeking solutions to skin-related problems. Our goal is to ensure that patients receive prompt and accessible care whenever they need it.",
          "We designed and developed an app specifically for patients seeking solutions to skin-related problems. Our goal is to ensure that patients receive prompt and accessible care whenever they need it."
        ],
        card: {
          icon: "<IoPerson className='text-center h1' size={60} />", // render in JSX
          title: "Client Requirements",
          description: "Capture & highlight patient skin problem pictures, engage in direct conversations and save consultation progress as drafts.",
          backgroundColor: "#8d92ff",
          borderRadius: "28px",
          color: "white",
          width: "500px",
          height: "320px",
        }
      },
      {
        cards: [
          {
            icon: "<IoBagSharp className='text-center h1' size={60} />",
            title: "Results Oriented Execution",
            description: "Capture & highlight patient skin problem pictures, engage in direct conversations and save consultation progress as drafts.",
            backgroundColor: "#8d92ff",
            borderRadius: "28px",
            color: "white",
            width: "500px",
            height: "320px",
          },
          {
            icon: "<IoAirplane className='text-center h1' size={60} />",
            title: "Solutions We Offered",
            description: "Capture & highlight patient skin problem pictures, engage in direct conversations and save consultation progress as drafts.",
            backgroundColor: "#8d92ff",
            borderRadius: "28px",
            color: "white",
            width: "500px",
            height: "320px",
          }
        ]
      }
    ],

    sections: [
      {
        title: "Introduction Screen",
        subtitle: "Get Started: Journey to Healthy Skin",
        description: [
          `The application's introduction screen provides users with an overview of its features and functionalities.`,
          `Users can also switch between Dutch, French, and English languages.`,
        ],
        image: "https://d19cx7uv5wsln6.cloudfront.net/assets/images/dr-skin-fearures-img1.webp",
        reverse: false,
      },
      {
        title: "Home Screen",
        subtitle: "Welcome to the Dermatology Consult App",
        description: [
          `The Home screen displays ongoing or draft consultations.`,
          `It also provides an intuitive way to start new consultations.`,
        ],
        image: "https://d19cx7uv5wsln6.cloudfront.net/assets/images/dr-skin-fearures-img2.webp",
        reverse: true,
      },
      {
        title: "Consultation Screen",
        subtitle: "Expert Guidance at Your Fingertips",
        description: [
          `Shows a full overview of all consultations.`,
          `Users can view details, discussions, and attached files.`,
        ],
        image: "https://d19cx7uv5wsln6.cloudfront.net/assets/images/dr-skin-fearures-img3.webp",
        reverse: false,
      },
       {
        title: "Mobile & Web Screens",
        subtitle: "Seamless Design, Exceptional Experience",
        description: [
          `The mobile and web screens have been thoughtfully designed to provide a visually appealing and intuitive user experience.`,
          `The Mobile Screen is optimized for smartphones and tablets, featuring a responsive layout that adapts to different screen sizes.`,
          `The Web Screen offers a spacious and immersive layout for desktop and laptop users.`,
        ],
        image: "https://d19cx7uv5wsln6.cloudfront.net/assets/images/dr-skin-tab-mobile.webp",
        reverse: false,
      },
    ],
  },
];
